export default {
  handleDocumentContainer: {
    title: 'Joindre un devis',
    text: 'Concernant vos dommages immobilers, présentez-nous un devis d’un artisan de votre choix. Celui-ci sera revu par notre cellule technique qui le validera ou prendra contact avec vous si besoin.',
    actions: {
      primary: 'Continuer'
    },
    documentUploadStep: {
      actions: {
        primary: 'Joindre le document'
      }
    },
    icrModal: {
      title: 'Téléchargement de fichiers',
      text1: 'Les fichiers sont en cours de traitement. Sil vous plaît, continuez d’attendre.',
      text2: 'Le processus peut prendre quelques minutes.',
      text3: 'Nous traitons vos documents et vous informons du résultats en moins de deux minutes.'
    }
  }
}
